import { filledTokenSocials, trimOptionalUrl, type TokenSocials } from '@/lib/tokenSocials'

interface TokenSocialLinksProps {
  socials?: TokenSocials | null
  website?: string
  name?: string
  accent?: 'lime' | 'orange'
  embedded?: boolean
}

function TokenSocialLinks({ socials, website, name, accent = 'lime', embedded = false }: TokenSocialLinksProps) {
  const links = filledTokenSocials(socials)
  const site = trimOptionalUrl(website)
  if (!site && links.length === 0)
    return null

  const linkClass = accent === 'orange'
    ? 'text-orange-400 hover:text-orange-300'
    : 'text-lime-400 hover:text-lime-300'

  const list = (
    <div className={embedded ? 'mt-4 flex flex-col gap-2 text-sm' : 'mt-3 flex flex-col gap-2 text-sm'}>
      {site
        ? (
            <a href={site} target="_blank" rel="noopener noreferrer" className={linkClass}>
              Website
            </a>
          )
        : null}
      {links.map(link => (
        <a
          key={link.key}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${name ?? 'Token'} ${link.label}`}
          className={linkClass}
        >
          {link.label}
        </a>
      ))}
    </div>
  )

  if (embedded)
    return list

  return (
    <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-6 backdrop-blur-md">
      <h2 className="text-sm font-semibold text-white">Links</h2>
      {list}
    </div>
  )
}

export default TokenSocialLinks
